import React from 'react';
import { Collapse, Form, InputNumber, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { MAX_AMOUNT, supplierOrderAmountRule } from '../../../dto/supplierOrder';

const { Text } = Typography;

interface SupplierOrderManualCostOverrideProps {
  visible: boolean;
  addonAfter?: string;
  name?: string | (string | number)[];
}

const SupplierOrderManualCostOverride: React.FC<SupplierOrderManualCostOverrideProps> = ({
  visible,
  addonAfter,
  name = 'allocatedCostPLN',
}) => {
  const { t } = useTranslation(['orders']);

  if (!visible) return null;

  return (
    <>
      <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
        {t('orders:supplierOrders.form.automaticCostHint')}
      </Text>
      <Collapse
        size="small"
        ghost
        style={{ marginBottom: 16 }}
        items={[
          {
            key: 'manual-cost-override',
            label: t('orders:supplierOrders.form.manualCostOverrideTitle'),
            children: (
              <>
                <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
                  {t('orders:supplierOrders.form.manualCostOverrideHelp')}
                </Text>
                <Form.Item
                  name={name}
                  label={t('orders:supplierOrders.form.manualAllocatedCostPLN')}
                  rules={[supplierOrderAmountRule(t)]}
                  style={{ marginBottom: 0 }}
                >
                  <InputNumber
                    min={0}
                    max={MAX_AMOUNT}
                    precision={2}
                    style={{ width: '100%' }}
                    addonAfter={addonAfter}
                  />
                </Form.Item>
              </>
            ),
          },
        ]}
      />
    </>
  );
};

export default SupplierOrderManualCostOverride;
